<template>
  <v-toolbar flat color="transparent" :class="{'shiftMenuDown':wizardOpen,'mb-5':$vuetify.breakpoint.xsOnly}">
    <v-toolbar-title style="overflow:visible;">
      <img :src="cdn + 'logo.png'" style="width: 110px; transform:translateY(15px);" />
    </v-toolbar-title>
    <v-spacer></v-spacer>

    <template v-if="isAuthorized">
      <v-menu 
        v-if="isAuthorized"
        offset-y
        transition="slide-y-transition"
        bottom
        left
      >
        <template v-slot:activator="{ on }">
          <v-btn flat v-on="on">
            MY ACCOUNT
          </v-btn>
        </template>
        <v-list style="min-width: 150px;">
          <v-list-tile :to="{name: 'account-trips'}">
            <v-list-tile-title>Trips</v-list-tile-title>
          </v-list-tile>
          <v-list-tile :to="{name: 'account-profile'}">
            <v-list-tile-title>Profile</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="logout">
            <v-list-tile-title>Logout</v-list-tile-title>
          </v-list-tile>
        </v-list>
        <v-divider v-if="isStylist"></v-divider>
        <v-list v-if="isStylist">
          <v-list-tile :to="{name: 'admin-dashboard'}">
            <v-list-tile-title>Admin</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>

      <v-btn v-if="!wizardOpen && isAuthorized" color="primary" :to="{name:'trip', params:{id:'new'}}">
        New Trip
      </v-btn>
    </template>

    
  </v-toolbar>
</template>

<script>

export default {
  name: 'TopMenu',
  data () {
    return {
    }
  },
  computed: {
    cdn: function() {
      return this.$root.cdn;
    },
    user: function() {
      return this.$store.getters.user;
    },
    isAuthorized: function() {
      return this.$store.getters.isAuthorized;
    },
    isStylist: function() {
      return this.$store.getters.isStylist;
    },
    isAdmin: function() {
      return this.$store.getters.isAdmin;
    },
    wizardOpen: function() {
      return (this.$store.getters.wizardNavigator.show && this.$vuetify.breakpoint.smAndUp);
    }
  },
  methods: {
    logout: function() {
      this.$store.dispatch('deauthorize');
    }
  }
}
</script>
